var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hamburger",on:{"click":_vm.toggleClick}},[_c('i',{class:_vm.isActive ? 'el-icon-arrow-left':'el-icon-arrow-right'})])
}
var staticRenderFns = []

export { render, staticRenderFns }